module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch2"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage3"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch2.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-2"
    }
  }, [_vm._v("You rush to the next room, expecting something exciting. But your mom is standing in front of a sundial. “Isn’t this wonderful?” she exclaims. “An exhibit on time!”")])]), _c('a', {
    attrs: {
      "id": "pg-2"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Great, you think. A whole roomful of clocks! Boring!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then Denny gives you a karate kick in the back of the leg.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ow!” you cry. “Stop it!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re not the boss of me!” he says smugly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, I am!” you reply, punching him in the arm. He whines and complains to your parents. You can’t win!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m thirsty,” Denny says now. You can see he’s eaten almost half a bag of Gummi Bears in less than a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can you find a drinking fountain for Denny, dear?” your mom asks without taking her eyes off a grandfather clock.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on.” You grab Denny’s hand. But Denny pulls away and runs off down a hallway. You follow him. The hallway twists and turns. There’s no sign of either Denny or a water fountain. But near the end of the hall you see a sign on a door:")]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WARNING!")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("DANGEROUS EXPERIMENT INSIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("THIS DOOR MUST BE KEPT LOCKED AT ALL TIMES")])])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Go on to ")])]), _c('a', {
    attrs: {
      "href": "#/e9780545841016_ch003"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 3")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3618f8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841016_ch002.vue
// module id = 69
// module chunks = 0